import gql from 'graphql-tag';

export const DOWNLOAD_MEMBER_CSV = gql`
  query DownloadMemberCSVQuery($query: JSONObject!, $columns: SelectedColumnsInput!) {
    csv: downloadMemberCSV(query: $query, columns: $columns)
  }
`;
